export function to24HourFormatStartTime(time: string): string {
  return to24HourFormat(time, true);
}

export function to24HourFormatEndTime(time: string): string {
  return to24HourFormat(time, false);
}

function to24HourFormat(time: string, startTime: boolean): string {
  const [hourMinute, period] = time.trim().split(' ');
  let [hour, minute] = hourMinute.split(':').map(Number);

  if (period.toUpperCase() === 'PM' && hour < 12) {
    hour += 12;
  }
  if (period.toUpperCase() === 'AM' && hour === 12 && startTime) {
    hour = 0;
  }
  if (period.toUpperCase() === 'AM' && hour === 12 && !startTime) {
    hour = 24;
  }

  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
}

export function toAmPmFormat(time: string): string {
  let [hour, minute] = time.split(':').map(Number);
  const period = hour >= 12 && hour < 24 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${period}`;
}

export function generateHours() {
  const periods = ['AM', 'PM'];
  const hours = Array.from({ length: 12 }, (_, i) => (i + 1) % 12 || 12); // Generates [12, 1, 2, ..., 11]
  const minutes = Array.from({ length: 4 }, (_, i) => i * 15); // Generates [0, 15, 30, 45]

  // Generate times in proper order
  const hourOptions = periods.flatMap((period) =>
    hours.flatMap((hour) =>
      minutes.map((minute) => {
        const hourStr = hour.toString().padStart(2, '0');
        const minuteStr = minute.toString().padStart(2, '0');
        return `${hourStr}:${minuteStr} ${period}`;
      }),
    ),
  );

  // Ensure times are in the correct sequence for a day
  hourOptions.sort((a, b) => {
    const convertTo24Hour = (time: string): number => {
      const [timeString, period] = time.split(' ');
      const [hour, minute] = timeString.split(':').map(Number);

      let hour24 = hour % 12; // Convert 12-hour to base (0-11)
      if (period === 'PM') hour24 += 12; // Add 12 for PM (except for 12 PM)
      if (period === 'AM' && hour === 12) hour24 = 0; // Midnight is 0:00

      return hour24 * 60 + minute; // Total minutes since 00:00
    };

    return convertTo24Hour(a) - convertTo24Hour(b);
  });

  return hourOptions;
}

export function isLessThanOrEqual(current: string, checkAgainst: string): boolean {
  if (!current || !checkAgainst) {
    return false;
  }
  const convertTo24Hour = (time: string): number => {
    const [timeString, period] = time.split(' ');
    let [hour, minute] = timeString.split(':').map(Number);

    if (period === 'AM') {
      hour = hour === 12 ? 0 : hour;
    } else {
      hour = hour === 12 ? 12 : hour + 12;
    }

    return hour * 60 + minute;
  };

  const currentMinutes = convertTo24Hour(current);
  const checkAgainstMinutes = convertTo24Hour(checkAgainst);

  return currentMinutes <= checkAgainstMinutes;
}
